import {useStaticRendering} from 'mobx-react';

import {sessionStore} from './session';
import SystemStore, {systemStore} from './system';
import LanguageStore, {languageStore} from './language';
import PermissionStore from './permission';
import UserStore from './user';
import GameStore from './game';
import SocketStore from './socket';
import LobbySocketStore from './lobbySocket';
import VerificationStore, {verificationStore} from './verification';

const isServer = typeof window === 'undefined';
useStaticRendering(isServer);

let store = null;

export default function initializeStore(initialData = {language: {}}) {
  const {language} = initialData;
  if (isServer) {
    const serverLanguageStore = new LanguageStore();
    serverLanguageStore.initLanguage(language);
    return {
      session: sessionStore,
      permission: new PermissionStore(sessionStore),
      language: serverLanguageStore,
      user: new UserStore(sessionStore, systemStore, serverLanguageStore),
      system: new SystemStore(),
      verification: new VerificationStore(),
      game: new GameStore(),
    };
  }
  if (store === null) {
    languageStore.initLanguage(language);
    const userStore = new UserStore(sessionStore, systemStore, languageStore);
    store = {
      session: sessionStore,
      permission: new PermissionStore(sessionStore),
      language: languageStore,
      user: userStore,
      system: systemStore,
      verification: verificationStore,
      socket: new SocketStore(systemStore, userStore),
      game: new GameStore(),
      lobbySocket: new LobbySocketStore(systemStore, userStore),
    };
  }
  return store;
}
